export default "/images/avatar.png?adac3e877c40a11bf568ed92bf6096d9";